export default {"src":"/_next/static/media/card-placeholder-3.4a19e217.svg","height":162,"width":231,"blurWidth":0,"blurHeight":0};